import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducers from '../reducers'
import thunkMiddleware from 'redux-thunk'
//Take index from sagas folder
import sagas from '../sagas'
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'

module.exports = function(initialState) {
  const sagaMiddleware = createSagaMiddleware(sagas);
  const store = createStore(reducers, initialState,
    compose(
      applyMiddleware(
        thunkMiddleware,
        sagaMiddleware,
        routerMiddleware(browserHistory)
      ),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  );
  if (module.hot) {

    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers')
      store.replaceReducer(nextReducer)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/stores/index.js